import React from "react";

import { Typography } from "@mui/material";

import { ReactComponent as ClockIcon } from "assets/images/icon-time-clock.svg";

import "./index.scss";

interface DateChipProps {
  date: string;
}

const DateChip: React.FC<DateChipProps> = ({ date }) => {
  return (
    <div className="date-chip">
      <ClockIcon />
      <Typography variant="subtitle2">{date}</Typography>
    </div>
  );
};

export default DateChip;
